import * as api from "../Api";

export const getAdminForecast = () => async (dispatch) => {
  try {
    const { data } = await api.forecast_data();
    dispatch({ type: "GET_ADMIN_FORECAST", payload: data });
  } catch (error) {}
};
